/*
 * Automatically generated by codegen/smith.ts.
 * Do not edit this file or add other files to this directory.
 */
import { seamApiLtsVersion } from '../../../../../lib/lts-version.js';
import { getAuthHeadersForClientSessionToken, warnOnInsecureuserIdentifierKey, } from '../../../../../lib/seam/connect/auth.js';
import { createClient } from '../../../../../lib/seam/connect/client.js';
import { isSeamHttpOptionsWithApiKey, isSeamHttpOptionsWithClient, isSeamHttpOptionsWithClientSessionToken, isSeamHttpOptionsWithConsoleSessionToken, isSeamHttpOptionsWithPersonalAccessToken, SeamHttpInvalidOptionsError, } from '../../../../../lib/seam/connect/options.js';
import { limitToSeamHttpRequestOptions, parseOptions, } from '../../../../../lib/seam/connect/parse-options.js';
import { SeamHttpClientSessions } from '../../../../../lib/seam/connect/routes/client-sessions/index.js';
import { SeamHttpRequest } from '../../../../../lib/seam/connect/seam-http-request.js';
import { SeamPaginator } from '../../../../../lib/seam/connect/seam-paginator.js';
export class SeamHttpConnectWebviews {
    client;
    defaults;
    ltsVersion = seamApiLtsVersion;
    static ltsVersion = seamApiLtsVersion;
    constructor(apiKeyOrOptions = {}) {
        const options = parseOptions(apiKeyOrOptions);
        this.client = 'client' in options ? options.client : createClient(options);
        this.defaults = limitToSeamHttpRequestOptions(options);
    }
    static fromClient(client, options = {}) {
        const constructorOptions = { ...options, client };
        if (!isSeamHttpOptionsWithClient(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing client');
        }
        return new SeamHttpConnectWebviews(constructorOptions);
    }
    static fromApiKey(apiKey, options = {}) {
        const constructorOptions = { ...options, apiKey };
        if (!isSeamHttpOptionsWithApiKey(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing apiKey');
        }
        return new SeamHttpConnectWebviews(constructorOptions);
    }
    static fromClientSessionToken(clientSessionToken, options = {}) {
        const constructorOptions = { ...options, clientSessionToken };
        if (!isSeamHttpOptionsWithClientSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing clientSessionToken');
        }
        return new SeamHttpConnectWebviews(constructorOptions);
    }
    static async fromPublishableKey(publishableKey, userIdentifierKey, options = {}) {
        warnOnInsecureuserIdentifierKey(userIdentifierKey);
        const clientOptions = parseOptions({ ...options, publishableKey });
        if (isSeamHttpOptionsWithClient(clientOptions)) {
            throw new SeamHttpInvalidOptionsError('The client option cannot be used with SeamHttpConnectWebviews.fromPublishableKey');
        }
        const client = createClient(clientOptions);
        const clientSessions = SeamHttpClientSessions.fromClient(client);
        const { token } = await clientSessions.getOrCreate({
            user_identifier_key: userIdentifierKey,
        });
        return SeamHttpConnectWebviews.fromClientSessionToken(token, options);
    }
    static fromConsoleSessionToken(consoleSessionToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, consoleSessionToken, workspaceId };
        if (!isSeamHttpOptionsWithConsoleSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing consoleSessionToken or workspaceId');
        }
        return new SeamHttpConnectWebviews(constructorOptions);
    }
    static fromPersonalAccessToken(personalAccessToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, personalAccessToken, workspaceId };
        if (!isSeamHttpOptionsWithPersonalAccessToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing personalAccessToken or workspaceId');
        }
        return new SeamHttpConnectWebviews(constructorOptions);
    }
    createPaginator(request) {
        return new SeamPaginator(this, request);
    }
    async updateClientSessionToken(clientSessionToken) {
        const { headers } = this.client.defaults;
        const authHeaders = getAuthHeadersForClientSessionToken({
            clientSessionToken,
        });
        for (const key of Object.keys(authHeaders)) {
            if (headers[key] == null) {
                throw new Error('Cannot update a clientSessionToken on a client created without a clientSessionToken');
            }
        }
        this.client.defaults.headers = { ...headers, ...authHeaders };
        const clientSessions = SeamHttpClientSessions.fromClient(this.client);
        await clientSessions.get();
    }
    create(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/connect_webviews/create',
            method: 'POST',
            body: parameters,
            responseKey: 'connect_webview',
            options,
        });
    }
    delete(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/connect_webviews/delete',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    get(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/connect_webviews/get',
            method: 'POST',
            body: parameters,
            responseKey: 'connect_webview',
            options,
        });
    }
    list(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/connect_webviews/list',
            method: 'POST',
            body: parameters,
            responseKey: 'connect_webviews',
            options,
        });
    }
}
//# sourceMappingURL=connect-webviews.js.map